import { jsx as n } from "react/jsx-runtime";
import { c } from "../../../index-2QXL0WYc.js";
import { s as m } from "../../../Popover.module-DJ-RK5B3.js";
import { usePopover as F } from "../hooks/usePopover.js";
import { k as g, F as h, l as p, m as i, n as P, p as I, q as N } from "../../../floating-ui.react-SmaXvp4L.js";
import { composePopoverFloatingProps as x } from "../helpers/composeFloatingProps.js";
const l = ({
  children: e,
  className: o,
  displayMode: r,
  style: s,
  virtualFocus: a,
  ...f
}) => {
  const t = F();
  if (!t) return null;
  const u = x(
    t,
    r,
    s
  );
  return /* @__PURE__ */ n(I, { elementsRef: t.list, children: /* @__PURE__ */ n(
    N,
    {
      context: t.api.context,
      initialFocus: a ? -1 : 0,
      modal: !1,
      disabled: !(t != null && t.show),
      returnFocus: !a,
      children: /* @__PURE__ */ n(
        "div",
        {
          ...f,
          className: c(o, m.content),
          hidden: !(t != null && t.show),
          ref: t == null ? void 0 : t.api.refs.setFloating,
          ...u,
          children: e
        }
      )
    }
  ) });
}, d = ({
  className: e,
  container: o,
  ...r
}) => {
  const s = p();
  return o ? /* @__PURE__ */ n(i, { id: s, children: /* @__PURE__ */ n(P, { root: o, preserveTabOrder: !0, children: /* @__PURE__ */ n(
    l,
    {
      ...r,
      className: c(e, m.portal)
    }
  ) }) }) : /* @__PURE__ */ n(i, { id: s, children: /* @__PURE__ */ n(l, { ...r, className: e }) });
}, q = (e) => g() === null ? /* @__PURE__ */ n(h, { children: /* @__PURE__ */ n(d, { ...e }) }) : /* @__PURE__ */ n(d, { ...e });
export {
  q as PopoverContent
};
